import React, {Fragment} from 'react';
import {Button, Flex, NavLink, Layout, Clarity, Route, Switch, Next, Breadcrumbs} from 'components';
import {capitalize, config, usePages} from 'helpers';

export function Router() {
  const {title, prev, total, current} = usePages();
  return (
    <Fragment>
      <Layout.Title>{ capitalize(config.clarityModule) }</Layout.Title>
      <Layout.Topbar.Tabs>
        <NavLink to={`/${config.clarityModule}/`}>{ capitalize(config.clarityModule) }</NavLink>
      </Layout.Topbar.Tabs>
      <Clarity.Sidebar />
      <main>
        <Layout.Header>
          <Flex>
            <div className="pull-left">
              <h1>{ title }</h1>
              <Breadcrumbs className="small-spacing">
                { capitalize(config.clarityModule) }
                <b className='multi-line'>{ current } of { total }</b>
              </Breadcrumbs>
            </div>
            {prev &&
              <Button to={prev} className={['small', 'borderless']} icon="return">
                Back
              </Button>
            }
            <Next className={['primary', 'small']} rightIcon="arrow-right" />
          </Flex>
        </Layout.Header>
        <Switch>
          <Route exact path="*/career/" component={Clarity.Career} />
          <Route exact path="*/career/goal-actions/" component={Clarity.CareerGoalActions} />
          <Route exact path="*/growth/" component={Clarity.Growth} />
          <Route exact path="*/growth/goal-actions/" component={Clarity.GrowthGoalActions} />
          <Route exact path="*/health/" component={Clarity.Health} />
          <Route exact path="*/health/goal-actions/" component={Clarity.HealthGoalActions} />
          <Route exact path="*/how-are-you" component={Clarity.HowAreYou} />
          <Route exact path="*/lifestyle/" component={Clarity.Lifestyle} />
          <Route exact path="*/lifestyle/goal-actions/" component={Clarity.LifestyleGoalActions} />
          <Route exact path="*/reality-check/" component={Clarity.RealityCheck} />
          <Route exact path="*/reality-check/continue/" component={Clarity.RealityCheckContinue} />
          <Route exact path="*/relationships/" component={Clarity.Relationships} />
          <Route exact path="*/relationships/goal-actions/" component={Clarity.RelationshipsGoalActions} />
          <Route exact path="*/social/" component={Clarity.Social} />
          <Route exact path="*/social/goal-actions/" component={Clarity.SocialGoalActions} />
          <Route exact path="*/spirituality/" component={Clarity.Spirituality} />
          <Route exact path="*/spirituality/goal-actions/" component={Clarity.SpiritualityGoalActions} />
          <Route exact path="*/wealth/" component={Clarity.Wealth} />
          <Route exact path="*/wealth/goal-actions/" component={Clarity.WealthGoalActions} />
          <Route exact path="*/whats-next/" component={Clarity.WhatsNext} />
          <Route exact component={Clarity.Intro} />
        </Switch>
      </main>
    </Fragment>
  );
}
